const { default: axiosIns } = require('@/libs/axios')

const AccountAdminService = {
  // GET - AccountApiController
  async getUsers() {
    return axiosIns.get('admin/accounts/users').then(response => response.data)
  },
  async getAccounts() {
    return axiosIns.get('admin/accounts').then(response => response.data)
  },
  async getWithdraws() {
    return axiosIns.get('/admin/accounts/withdraws').then(response => response.data)
  },
  async getTransactions() {
    return axiosIns.get('admin/accounts/transactions').then(response => response.data)
  },
  async getAllAccounts(searchTerm = '') {
    return axiosIns.get('admin/accounts/all', {
      params: { searchTerm },
    }).then(response => response.data)
  },
  // DELETE - AccountApiController
  async deleteUser(model) {
    return axiosIns.delete(`admin/accounts/users/${model.userId}`, {
      data: {
        ...model,
      },
    }).then(response => response.data)
  },
  async deleteAccount(account) {
    return axiosIns.delete(`admin/accounts/${account.id}`, {
      data: {
        ...account,
      },
    }).then(response => response.data)
  },
  // POST - AccountApiController
  async createPlatformUser(user) {
    return axiosIns.post('admin/accounts/users/create', user).then(response => response.data)
  },
  async getFilteredAccounts(wrapper) {
    return axiosIns.post('admin/accounts/filters', wrapper).then(response => response.data)
  },
  async getFilteredWithdraws(filter) {
    return axiosIns.post('admin/accounts/withdraws/filters', filter).then(response => response.data)
  },
  async getFilteredUsers(filter) {
    return axiosIns.post('admin/accounts/users/filters', filter).then(response => response.data)
  },
  async getFilteredTransactions(transactionWrapper) {
    return axiosIns.post('admin/accounts/transactions/filters', transactionWrapper).then(response => response.data)
  },
  // PUT - AccountApiController
  async updatePlatformUser(user) {
    return axiosIns.put(`admin/accounts/users/${user.id}`, user).then(response => response.data)
  },
  async updateTransactionStatus(filter, status) {
    return axiosIns.put(`admin/accounts/transactions/${filter.id}?status=${status}`, filter).then(response => response.data)
  },
  async  updateWithdrawRequest(withdrawInfo, status) {
    return axiosIns.put(`/admin/accounts/withdraws/${withdrawInfo.id}?status=${status}`, withdrawInfo)
      .then(response => response.data)
  },
  async updateAccount(account) {
    return axiosIns.put(`admin/accounts/${account.id}`, account).then(response => response.data)
  },
}

export default AccountAdminService
